export default "__VITE_ASSET__Cs98O7ZA__"